export const SET_AUFTRAG_STATI = "setAuftragsStati";
export const SET_BUCHUNG_STATI = "setBuchungsStati";
export const SET_QUELLE_AUFTRAG = "setQuelleAuftrag";
export const SET_ZAHLUNGS_KONDITION = "setZahlungsKonditionen";
export const SET_ZAHLUNGS_PLAN = "setZahlungsPlan";
export const SET_KONTO = "setKonto";
export const SET_WAEHRUNG = "setWaehrung";
export const SET_ZAHLUNGS_VERBINDUNG = "setZahlungsVerbindung";
export const SET_VERSANDART = "setVersandart";
